import { BulletPointsData } from 'models/ai-chat/visualization.types';
import React from 'react';

interface BulletPointsProps {
  data: BulletPointsData;
}

const BulletPoints: React.FC<BulletPointsProps> = ({ data }) => {
  if (!data || !data.points || data.points.length === 0) {
    return <div className="text-center p-4 text-CuttySark">No bullet points to display</div>;
  }

  return (
    <div className="p-4 rounded-lg bg-WhiteLilac">
      <h3 className="text-lg font-semibold mb-3 text-Cello">{data.title}</h3>
      <ul className="space-y-3">
        {data.points.map((point, index) => (
          <li 
            key={index}
            className="pl-3 border-l-2 border-DodgerBlue bg-White p-3 rounded-md shadow-sm"
          >
            <div className="font-medium text-LimedSpruce">{point.text}</div>
            {point.details && point.details.length > 0 && (
              <ul className="mt-2 space-y-1">
                {point.details.map((detail, detailIndex) => (
                  <li 
                    key={detailIndex}
                    className="text-sm text-CuttySark flex items-start"
                  >
                    <span className="inline-block w-1 h-1 rounded-full bg-GullGray mt-1.5 mr-2"></span>
                    {detail}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BulletPoints;